

































import Vue, { PropType } from 'vue';

// models
import { VideoChat } from '~/models/communication';

// compoents
import Icon from '~/components/builders/Base/Icon.vue';

export default Vue.extend({
    name: 'MinimizedVideo',
    components: {
        Icon,
    },
    props: {
        videoChat: {
            required: true,
            type: Object as PropType<VideoChat>,
        },
    },
    computed: {
        interfaces(): any {
            return (this as any).$interfaces;
        },
    },
    methods: {
        changeSize(): void {
            if (this.videoChat.minimized) {
                // @ts-ignore TODO: Fix this
                this.$interfaces.videoCallModule.maximizeVideoChat(this.videoChat.id);
            } else {
                // @ts-ignore TODO: Fix this
                this.$interfaces.videoCallModule.minimizeVideoChat(this.videoChat.id);
            }
        },
        endCall(): void {
            // @ts-ignore TODO: Fix this
            this.$interfaces.videoCallModule.deleteVideoChat(this.videoChat.id);
        },
    },
});
